import React, { useState, useEffect } from "react";
import { TextInput, SelectInput } from "../../Components/Inputs";
import init_member from "../init_member";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";

const Edit = () => {
  const [roles, setRoles] = useState([]);
  const [input, setInput] = useState(init_member);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const request = useAxios();
  const { id } = useParams();

  useEffect(() => {
    getMemberDetails();
    getRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getMemberDetails() {
    let res = await request({
      method: "get",
      url: "members/single-member",
      params: { id: parseInt(id) },
    });
    if (res === "error") return;

    const inputCpy = { ...init_member };
    inputCpy.name.value = res?.name || "";
    inputCpy.email.value = res?.email || "";
    inputCpy.phone.value = res?.phone || "";
    inputCpy.role_id.value = res?.role_id || "";
    inputCpy.status.value = res?.status || "";
    setInput(inputCpy);
  }

  async function getRoles() {
    let res = await request({
      method: "get",
      url: "roles/all",
      show_loading: false,
    });
    if (res !== "error") {
      setRoles(res?.docs || []);
    }
  }

  const handleSubmit = async (data) => {
    setIsLoading(true);
    let res = await request({
      method: "PUT",
      url: `members/update`,
      body: {
        id: parseInt(id),
        ...data,
      },
      show_loading: true,
      loadingFunc: setIsLoading,
    });

    if (res !== "error") {
      navigate("/dashboard/members");
    }
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12 rounded-md">
      <h3 className="text-center text-2xl font-bold text-gray-700 mb-6">
        Edit Member
      </h3>

      <TextInput
        input={input}
        setInput={setInput}
        field="name"
        validate={validate}
      />

      <div className="flex gap-5 items-center max-md:flex-col">
        <TextInput
          input={input}
          setInput={setInput}
          field="email"
          validate={validate}
        />
        <TextInput
          input={input}
          setInput={setInput}
          field="phone"
          validate={validate}
        />
      </div>

      <div className="flex gap-5 items-center max-md:flex-col">
        <SelectInput
          input={input}
          setInput={setInput}
          field="role_id"
          validate={validate}
        >
          <option value="" disabled>
            Select Role
          </option>
          {roles.map((item, i) => (
            <option key={i} value={item.id}>
              {item.name}
            </option>
          ))}
        </SelectInput>

        <SelectInput
          input={input}
          setInput={setInput}
          field="status"
          validate={validate}
        >
          <option value="" disabled>
            Select Status
          </option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </SelectInput>
      </div>

      <div className="mt-6 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/members")}>Back</Btn>
        <Btn onClick={handleValidation} disabled={isLoading}>
          {isLoading ? "updating..." : "Submit"}
        </Btn>
      </div>
    </div>
  );
};

export default Edit;
